import { PhosphorCheckCircle, PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";

interface Props {
  label: string;
  subLabel: string;
  icon: "ok" | "warning" | "error" | "none";
}

export const PeppolStatus = (props: Props) => {
  return <div className="flex gap">
    {props.icon !== "none" && <div>
      {props.icon === "error" && <PhosphorWarningCircle iconSize="large" iconWeight="fill" iconColor="error" />}
      {props.icon === "warning" && <PhosphorWarningCircle iconSize="large" iconWeight="fill" iconColor="yellow" />}
      {props.icon === "ok" && <PhosphorCheckCircle iconSize="large" iconWeight="fill" iconColor="green" />}
    </div>}
    <div>
      <SmallDetails
        label={props.label}
        subLabel={props.subLabel}
      />
    </div>
  </div>
}